import {
  formatDate,
  isOnOrAfterToday,
  toValidDate,
} from '../../utils/helpers/date.helper';

export const displayGuarantee = (
  warrantyEndDate,
  underText,
  validText,
  dateFormat,
) => {
  const endDate = toValidDate(warrantyEndDate);

  if (!endDate || !isOnOrAfterToday(endDate)) {
    return null;
  }

  const formattedEndDate = formatDate(endDate, dateFormat);

  if (!formattedEndDate) {
    return null;
  }

  return (
    <div className="statusGuarantee">
      <strong>{underText} </strong>
      <div>
        {validText}{' '}
        <time dateTime={endDate.toISOString()}>{formattedEndDate}</time>
      </div>
    </div>
  );
};
